import React, { useEffect, useState } from 'react'

import {
  Navigate,
  Route,
  Routes as Switch,
  useSearchParams,
} from 'react-router-dom'

import routes from '@/utils/routes'

import RouteComponent from '@/components/RouteComponent'

import { useAuthDataHandler } from '@/blocks/Auth/hooks'

import { useLanguage } from './utils/localization/LanguageContext'

const routesArray = Object.values(routes)

const Routes = () => {
  const { changeLang } = useLanguage()

  const [searchParams] = useSearchParams()

  const { getLoginSessionData, getDefaultHomePage } = useAuthDataHandler()
  const { services } = getLoginSessionData() ?? {}

  const [defaultHomePage, setDefaultHomePage] = useState('')

  useEffect(() => {
    const lang = searchParams.get('lang')
    if (lang) {
      changeLang(lang)
    }
  }, [])
  useEffect(() => {
    setDefaultHomePage(getDefaultHomePage(services))
  }, [services])

  return (
    <Switch>
      {routesArray.map(({ path, ...props }) => (
        <Route key={path} path={path} element={<RouteComponent {...props} />} />
      ))}
      <Route path='*' element={<Navigate to={defaultHomePage} replace />} />
    </Switch>
  )
}

export default Routes
